<div [ngClass]="avatarContainerClass">
  <div [ngClass]="avatarVariantContainerClass">
    <ng-container *ngIf="isString(avatarType)">
      {{ avatarType }}
    </ng-container>
    <ng-container *ngIf="!isString(avatarType)">
      <ng-container *ngTemplateOutlet="avatarType"></ng-container>
    </ng-container>
    <!-- <ng-template #templateType>
      <ng-container *ngTemplateOutlet="avatarType"></ng-container>
    </ng-template> -->
  </div>
  <div *ngIf="showLogo && !floatingIcon" class="avatar-logo"></div>
  <div *ngIf="floatingIcon && avatarStyle === 'ghost'" [ngClass]="logoContainerClass">
    <ng-container *ngIf="isObject(floatingIcon)">
      <ng-container [ngTemplateOutlet]="floatingIcon.logo"></ng-container>
    </ng-container>
  </div>
</div>
